import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    fontWeight: "bold",
    fontSize: 12,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: 0,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const SectionTitle = ({ children, compact = false }) => (
  <h6
    className="section-title"
    style={{
      backgroundColor: compact ? undefined : "#4791e6ff",
      color: "white",
      padding: "2px 5px",
      borderRadius: compact ? undefined : 8,
      margin: compact ? 0 : undefined,
      marginBottom: compact ? undefined : 4,
    }}
  >
    {children}
  </h6>
);

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB");
};

export const formatAmount = (value) =>
  value
    ? parseFloat(value).toLocaleString("en-BD", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";

export const calculateSettlementTotals = (details = []) => ({
  totalAmount: details.reduce((acc, curr) => acc + Number(curr.amount || 0), 0),
  totalSuspenseAmount: details.reduce((acc, curr) => acc + Number(curr.suspenseAmount || 0), 0),
});
